export default __webpack_public_path__ + "static/media/DaimlerCS-Regular.dc279821.svg";